<template>
  <el-dialog
    title="历史版本"
    :visible.sync="visible"
    width="80%"
    @close="$emit('update:show', false)"
    @open="opened"
  >
    <div slot="title" class="flex-row-between" style="padding: 16px 16px 0">
      <el-select v-model="selectedIndex" placeholder="请选择">
        <el-option
          v-for="(version, i) in versions"
          :key="version.title"
          :label="version.title"
          :value="i"
        >
        </el-option>
      </el-select>
      <div class="text-info-12" v-if="order_info">
        {{ formatTime(order_info.created_at, 'YYYY-MM-DD hh:mm') }}
      </div>
    </div>

    <div v-if="order_info" style="padding: 0 16px">
      <div v-if="order_info.products.length > 0">
        <div class="header">
          <h2>产品</h2>
        </div>
        <el-table :data="order_info.products" style="width: 100%">
          <el-table-column prop="name" label="件号">
            <template slot-scope="scope">
              <div>
                {{ scope.row.item.part_number }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="item.description"
            label="描述"
          ></el-table-column>
          <el-table-column prop="price" label="价格(￥)" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.price }}</div>
              <div class="price-info">
                <span>
                  原价：{{ scope.row.item.price }} (
                  {{
                    priceIncreasePercent(scope.row.item.price, scope.row.price)
                  }}%)
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="数量"
            width="80"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <div class="mt-20">
        <div class="header">
          <h2>结算</h2>
        </div>
        <ul class="fee-list">
          <li>
            <div class="title">小计</div>
            <div class="input"></div>
            <div class="symbol"></div>
            <div class="amount">{{ math.show(displayFee.item) }}</div>
          </li>
          <li>
            <div class="title">税费（13%）</div>
            <div class="input"></div>
            <div class="symbol">+</div>
            <div class="amount">{{ math.show(displayFee.tax) }}</div>
          </li>
          <li>
            <div class="title">杂项</div>
            <div class="input"></div>
            <div class="symbol">+</div>
            <div class="amount">{{ math.show(displayFee.labor) }}</div>
          </li>
          <li>
            <div class="title">折扣金额（含税）</div>
            <div class="input">约{{ math.show(displayFee.discount) }}%</div>
            <div class="symbol">-</div>
            <div class="amount">{{ math.show(displayFee.discount_value) }}</div>
          </li>
          <li>
            <div class="title">合计</div>
            <div class="input"></div>
            <div class="amount">
              {{ math.show(order_info.amount) }}
            </div>
          </li>
        </ul>
        <!-- <div class="estimate-profit">
          <div class>
            <i class="el-icon-money"></i>
            预计利润：
            <span v-html="profit"></span>
          </div>
        </div> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import QuotationPrint from './quotation_print'
import { number } from 'mathjs/lib/entry/pureFunctionsAny.generated'
import { quotationVersionDetail } from '../service/getData'
import { numberMul, formatTime, priceIncreasePercent } from '@/util/index'
import math from '@/util/math'
import { DisplayOrderFee, CalculateProfit } from '@/util/order_calculate'

export default {
  components: { QuotationPrint },
  props: {
    quotation: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    versions: {
      type: Array,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
    index: function () {
      this.selectedIndex = this.index
    },
    selectedIndex: function () {
      let orderInfo = this.versions[this.selectedIndex].orderInfo
      if (!orderInfo) {
        this.requestQuotationVersion()
        return
      }
      this.order_info = this.versions[this.selectedIndex].orderInfo
    },
    order_info: function () {
      this.displayFee = DisplayOrderFee(this.order_info)

      let that = this
      CalculateProfit(this.order_info, function (profit) {
        that.profit = profit
      })
    },
  },
  data() {
    return {
      visible: this.show,
      order_info: null,
      math,
      formatTime,
      priceIncreasePercent,
      displayFee: {
        item: 0,
        tax: 0,
        labor: 0,
        discount: 0,
        total: 0,
      },
      selectedIndex: 0,
      profit: '',
    }
  },
  created() {},
  methods: {
    async requestQuotationVersion() {
      let index = this.selectedIndex
      let vid = this.versions[index].version.id
      let res = await quotationVersionDetail({
        id: this.quotation.id,
        vid: vid,
      })
      if (res.code == 0) {
        this.versions[index].orderInfo = res.data
        if (index == this.selectedIndex) {
          this.order_info = res.data
        }
      }
    },
    opened() {
      //   if (this.versions.length > 0 && this.quotation.id > 0) {
      //     this.requestQuotationVersion()
      //   }
    },
  },
}
</script>

<style scoped>
h2 {
  margin-bottom: 10px;
  display: block;
  font-size: 14px;
  color: #334152;
}
</style>